var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit_frame" },
    [
      _c("div", { staticClass: "title" }, [_vm._v(" 二维码区块 ")]),
      _vm.page.bodyConfig
        ? _c(
            "section",
            { staticClass: "text-content" },
            [
              _c("div", { staticClass: "subtitle" }, [_vm._v("二维码布局")]),
              _c(
                "el-radio-group",
                {
                  attrs: { direction: "horizontal" },
                  on: { change: _vm.layoutChange },
                  model: {
                    value: _vm.page.bodyConfig.qyCodeLayout,
                    callback: function ($$v) {
                      _vm.$set(_vm.page.bodyConfig, "qyCodeLayout", $$v)
                    },
                    expression: "page.bodyConfig.qyCodeLayout",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "left" } }, [
                    _vm._v(" 居左 "),
                  ]),
                  _c("el-radio", { attrs: { label: "right" } }, [
                    _vm._v(" 居右 "),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "subtitle" }, [_vm._v("二维码位置")]),
              _c(
                "el-radio-group",
                {
                  attrs: { direction: "horizontal" },
                  on: { change: _vm.locationChange },
                  model: {
                    value: _vm.page.bodyConfig.qyCodelocation,
                    callback: function ($$v) {
                      _vm.$set(_vm.page.bodyConfig, "qyCodelocation", $$v)
                    },
                    expression: "page.bodyConfig.qyCodelocation",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "top" } }, [
                    _vm._v(" 海报上方 "),
                  ]),
                  _c("el-radio", { attrs: { label: "bottom" } }, [
                    _vm._v(" 海报下方 "),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "subtitle" }, [_vm._v("分享文案标题")]),
              _c("el-input", {
                attrs: {
                  type: "text",
                  placeholder: "请输入",
                  size: "medium",
                  maxlength: "10",
                  "show-word-limit": "",
                },
                on: { change: _vm.titleChange },
                model: {
                  value: _vm.shareTitle,
                  callback: function ($$v) {
                    _vm.shareTitle = $$v
                  },
                  expression: "shareTitle",
                },
              }),
              _c("div", { staticClass: "subtitle" }, [_vm._v("分享文案正文")]),
              _c("el-input", {
                attrs: {
                  type: "text",
                  placeholder: "请输入",
                  size: "medium",
                  maxlength: "10",
                  "show-word-limit": "",
                },
                on: { change: _vm.textChange },
                model: {
                  value: _vm.shareText,
                  callback: function ($$v) {
                    _vm.shareText = $$v
                  },
                  expression: "shareText",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      [
        _c("div", { staticClass: "title" }, [_vm._v(" 职位信息 ")]),
        _c(
          "div",
          { staticClass: "position mt-20" },
          [
            _c(
              "el-checkbox-group",
              {
                attrs: { direction: "horizontal" },
                on: { change: _vm.handlePositionInfoChange },
                model: {
                  value: _vm.selectPositionInfoList,
                  callback: function ($$v) {
                    _vm.selectPositionInfoList = $$v
                  },
                  expression: "selectPositionInfoList",
                },
              },
              _vm._l(_vm.positionList, function (item) {
                return _c(
                  "el-checkbox",
                  { key: item.label, attrs: { label: item.label } },
                  [_vm._v(_vm._s(item.label))]
                )
              }),
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }